import { baseUrl, instance } from "./request"

export const getDocumentsTree = (data) => instance.get("/documents_tree", { data })

export const getDocumentsModules = (data) => instance.get("/documents_mokuai", { data })
